import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { migrateLocalStorage } from './utils/migrate';

// Upgrade any pre-existing bgt_* data to the current schema before React reads it.
migrateLocalStorage();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register the PWA service worker for offline support and "Add to Home Screen".
// The SW is only active in production builds (`npm run build`).
// During `npm start` this call is a no-op — CRA skips SW in dev to avoid caching issues.
serviceWorkerRegistration.register();
